import _asyncToGenerator from "E:/Deepin/Projects/spring-activity/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "E:/Deepin/Projects/spring-activity/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "E:/Deepin/Projects/spring-activity/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "vant/es/dialog/style";
import _Dialog from "vant/es/dialog";
import "vant/es/loading/style";
import _Loading from "vant/es/loading";
import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import "vant/es/empty/style";
import _Empty from "vant/es/empty";
import "vant/es/nav-bar/style";
import _NavBar from "vant/es/nav-bar";
import "vant/es/button/style";
import _Button from "vant/es/button";
import "vant/es/skeleton/style";
import _Skeleton from "vant/es/skeleton";
import "vant/es/pull-refresh/style";
import _PullRefresh from "vant/es/pull-refresh";
import "vant/es/list/style";
import _List from "vant/es/list";

var _components;

import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { Image as VanImage } from "vant/lib/image";
import help from "../assets/js/help";
import { mapMutations, mapState } from "vuex";
import invitationItem from "./invitationItem";
import OverlayWrapper from "./OverlayWrapper";
import bus from "vue3-eventbus";
export default {
  name: "ListInvitedWrapper",
  props: {
    categoryId: {
      type: [Number, String],
      default: 0
    }
  },
  components: (_components = {}, _defineProperty(_components, _List.name, _List), _defineProperty(_components, _PullRefresh.name, _PullRefresh), _defineProperty(_components, _Skeleton.name, _Skeleton), _defineProperty(_components, _Button.name, _Button), _defineProperty(_components, _NavBar.name, _NavBar), _defineProperty(_components, _Empty.name, _Empty), _defineProperty(_components, _Toast.name, _Toast), _defineProperty(_components, VanImage.name, VanImage), _defineProperty(_components, _Loading.name, _Loading), _defineProperty(_components, "Dialog", _Dialog), _defineProperty(_components, "invitationItem", invitationItem), _defineProperty(_components, "OverlayWrapper", OverlayWrapper), _components),
  data: function data() {
    return {
      border: false,
      finished: false,
      refreshing: false,
      loading: true,
      loadDate: false,
      dialogShow: false,
      dialogAddr: false,
      emptyImage: require("@/assets/images/content-null.png"),
      info: {},
      infoError: {},
      list: [],
      list2: [{}],
      page: 1,
      timer: "",
      chargeCoupeList: [{}]
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState(["uid", "token", "time", "phone", "isTest", "totalIngral", "type", "activeIndex", "isSelected", "shareTitle", "shareDesc", "shareImage", "bannerImage"])), {}, {
    notEmpty: function notEmpty() {
      return Object.keys(this.info).length;
    },
    ErrNotEmpty: function ErrNotEmpty() {
      return Object.keys(this.infoError).length;
    },
    url: function url() {
      if (this.isTest) {
        return "/club/json/data-list.json";
      } else {
        return "/app2/api/goods/get-goods-list";
      }
    },
    isDevelopment: function isDevelopment() {
      return process.env.NODE_ENV === "development";
    },
    status: function status() {
      var _this$info;

      return (_this$info = this.info) === null || _this$info === void 0 ? void 0 : _this$info.applicationStatus;
    },
    source: function source() {
      if (window.d1ev) {
        return 1;
      } else if (window.webkit) {
        return 2;
      } else {
        return 3;
      }
    },
    params: function params() {
      var applicationId = this.info.applicationId;
      return {
        "id": applicationId - 0,
        "time": this.time,
        "token": this.token,
        "uid": this.uid - 0
      };
    },
    shareUrl: function shareUrl() {
      var applicationId = this.info.applicationId;
      var mobile = this.phone;
      var uid = this.uid;

      var _applicationId = applicationId ? help.encode(applicationId) : "";

      var _mobile = mobile ? help.encode(mobile) : "";

      var _uid = mobile ? help.encode(uid) : "";

      if (this.uid && mobile && applicationId) {
        if (this.isTest) {
          return "https://d1ev-new.yiduyongche.com/spring-share/index.html?i=".concat(_mobile, "&a=").concat(_applicationId, "&u=").concat(_uid);
        } else {
          return "https://www.d1ev.com/special/spring-share/index.html?i=".concat(_mobile, "&a=").concat(_applicationId, "&u=").concat(_uid);
        }
      } else {
        console.log("参数缺失");
        return "";
      }
    },
    isFull: function isFull() {
      return this.info.inviteNum === this.info.invitationNum;
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapMutations(["setUid", "setTotalIngral", "setAppInfo", "setIsSelected", "setType", "setActiveIndex", "setHomeReset"])), {}, {
    doCancel: function doCancel() {
      this.setHomeReset(true);
      this.dialogShow = true; //this.cancelActivity();
    },
    shareFriends: function shareFriends() {
      var _document$querySelect;

      var param = {
        "title": this.shareTitle || document.title,
        "thumbImage": this.shareImage || "https://www.d1ev.com/special/circle/images/share-2.png",
        "description": this.shareDesc || ((_document$querySelect = document.querySelector("meta[name='description']")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.content) || "",
        "url": this.shareUrl
      };
      console.log(param);
      param.url ? window.startShare(param) : "";
    },
    cancelActivity: function cancelActivity() {
      var _this = this;

      this.dialogShow = false;
      this.axios.post("/api/activity/invitation-del", JSON.stringify(this.params), {
        headers: {
          "Content-Type": "application/json;charset=utf-8"
        }
      }).then(function (res) {
        if (res) {
          help.requestSuccess(res).then(function (res) {
            console.log(res);

            _this.getCurentInvationInfo();

            _this.setIsSelected("");
          }, function (err) {
            console.log(err);
            help.resError(err, true, _this.logout, _this.setTimeOut);
          });
        }
      }, function (err) {
        help.requestError(err);
      });
    },
    addAddress: function addAddress() {
      var _this2 = this;

      this.dialogAddr = true;
      console.log("buslisten");
      bus.on("overlayClose", function () {
        console.log(1);
        _this2.dialogAddr = false;
      });
    },
    getDateString: function getDateString() {
      var dateString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "2023-01-11T11:43:55Z";
      return dataString.split("T")[0];
    },
    initPage: function initPage() {
      if (!this.loadDate && this.loading) {
        this.getList();
        this.page += 1;
        this.loadDate = true;
      }
    },
    initList: function initList(res) {
      var _this3 = this;

      help.isArray(res.data) ? res.data.map(function (item, index) {
        var time = item.Early ? help.timeObj(item.Early.split("T")[0]).simpleDate : "";
        var _subsidy = item.TNGroupSubsidys;

        _this3.list.push({
          id: item.Id,
          type: item.goodsType,
          // 1虚拟 2实物
          mode: "scaleToFill",
          stock: item.stock
        });
      }) : help.requestNull();
    },
    getCurentInvationInfo: function getCurentInvationInfo() {
      var _this4 = this;

      var _uid = this.uid;
      this.axios.get("/api/activity/invitation-my-list?uid=".concat(_uid)).then(function (res) {
        if (res) {
          help.requestSuccess(res, true).then(function (res) {
            console.log(res);
            _this4.info = {};

            for (var i = 0; i < res.length; i++) {
              var e = res[i];

              if (e.status === "1" && e.applicationStatus !== "3" && e.applicationStatus !== "-1") {
                if (e.applicationStatus === "1") {
                  _this4.info = e;
                  return;
                } else {
                  _this4.info = e;
                }
              } else if (e.status === "3") {
                _this4.infoError = e;
              }
            }
          }, function (err) {
            console.log(err);
            help.resError(err, true, _this4.logout, _this4.setTimeOut);
          });
        }
      }, function (err) {
        help.requestError(err);
      });
    },
    getList: function getList() {
      var _this5 = this;

      var _uid = this.uid;
      this.axios.get("/api/activity/my-invitation-user-list?uid=".concat(_uid)).then(function (res) {
        if (res) {
          help.requestSuccess(res, true).then(function (res) {
            console.log(res);
            res.forEach(function (e) {
              _this5.list.push(e);
            });
            _this5.loading = false;
            _this5.loadDate = false;
            _this5.finished = true;

            if (_this5.isTimeOuted) {
              _this5.setTimeOut(false);
            }
          }, function (err) {
            console.log(err);
            help.resError(err, true, _this5.logout, _this5.setTimeOut);
          });
        }
      }, function (err) {
        help.requestError(err);
      });
    },
    onClickList: function onClickList(item) {
      console.log(item);

      var _id = item.id ? item.id : 1;

      if (process.env.NODE_ENV === "production") {
        this.setAppInfo("");
      }

      this.$router.push({
        path: "/detail/" + _id
      });
    },
    onClickRight: function onClickRight() {
      _Toast("按钮");
    },
    onLoad: function onLoad() {
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
        this.page = 1;
      }

      this.initPage();
    },
    onRefresh: function onRefresh() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this6.refreshing = true;
                _this6.finished = false;
                _this6.loading = true;

                _this6.onLoad();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getIntegral: function getIntegral() {
      if (!this.totalIngral) {
        this.setTotalIngral(10000);
      }
    }
  }),
  mounted: function mounted() {
    this.getCurentInvationInfo();
  }
};